import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { useTheme } from "@mui/material/styles";

const LoginDialog = ({ open, onClose, onLoginSuccess }) => {
  const theme = useTheme();
  const [step, setStep] = useState("enterMobile");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState();

  // Function implementations remain the same

  const isIndianMobileNumber = (number) => {
    return true;
    const pattern = /^[6-9]\d{9}$/; // Basic validation for Indian mobile numbers
    return pattern.test(number);
  };

  const handleSendOtp = async () => {
    if (isIndianMobileNumber(mobileNumber)) {
      try {
        const response = await fetch("https://stageapi.stage.in/v20/user/otp", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            lang: "hin",
            type: "web",
            mobileNumber: mobileNumber,
            deviceId: "your_device_id_here", // You might want to dynamically set this
          }),
        });
        const data = await response.json();
        console.log("data._id", data.data._id);
        if (response.ok) {
          setUserId(data.data._id); // Save the user ID for later use
          setStep("verifyOtp");
        } else {
          // Handle server errors or invalid responses
          alert(data.message || "Failed to send OTP. Please try again.");
        }
      } catch (error) {
        // Handle network errors
        alert("Network error. Please try again.");
      }
    } else {
      alert("Please enter a valid Indian mobile number.");
    }
  };

  const handleVerifyOtp = async () => {
    try {
      console.log("userId", userId);
      const response = await fetch(
        "https://stageapi.stage.in/v23/user/verifyOtp?platform=web",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: userId,
            otp: otp,
            whatsappOptInStatus: false,
            mobileNumber: mobileNumber,
            countryCode: "+91",
            platform: "web",
          }),
        }
      );
      //   const authToken = response.headers;

      const data = await response.json();
      if (response.ok) {
        console.log("data", data.data);
        console.log("access", data.data.access);
        const token = data?.data?.access;
        if (token) {
          // Save the token to localStorage
          localStorage.setItem("bearerToken", token);
          localStorage.setItem("userId", userId);
          try {
            if (typeof window.sendFbEvent === "function") {
              window.sendFbEvent("track", "CompleteRegistration");
            }
          } catch (error) {
            console.log("Error in fb event", error);
          }
          onLoginSuccess();
          onClose(); // Close the dialog on successful login
        } else if (data.responseCode != 200) {
          // Token not found in  response
          alert("Login not successful wrong otp");
        }
      } else {
        // Handle server errors or invalid responses
        alert(data.message || "Failed to verify OTP. Please try again.");
      }
    } catch (error) {
      // Handle network errors
      alert("Network error. Please try again.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "#2c2c2c",
        },
      }}
    >
      <DialogContent sx={{ backgroundColor: "#2c2c2c", color: "white" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {step === "verifyOtp" && (
            <>
              <TextField
                autoFocus
                margin="dense"
                id="mobileNumber"
                label="Mobile Number"
                type="text"
                disabled
                value={mobileNumber}
                variant="standard"
                InputLabelProps={{
                  style: { color: "white" },
                }}
                InputProps={{
                  style: { color: "white" },
                }}
              />
              <IconButton
                aria-label="edit"
                onClick={() => setStep("enterMobile")}
                sx={{ color: "white" }}
              >
                <EditIcon />
              </IconButton>
            </>
          )}
          {step === "enterMobile" && (
            <TextField
              autoFocus
              margin="dense"
              id="mobileNumber"
              label="Mobile Number"
              type="number"
              fullWidth
              variant="outlined"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              helperText="Enter your mobile number"
              FormHelperTextProps={{
                style: { color: "white" },
              }}
              InputLabelProps={{
                style: { color: "white", borderColor: "white" },
              }}
              InputProps={{
                style: { color: "white", borderColor: "white" },
              }}
            />
          )}
        </div>
        {step === "verifyOtp" && (
          <TextField
            autoFocus
            margin="dense"
            id="otp"
            label="OTP"
            type="text"
            fullWidth
            variant="outlined"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            helperText="Enter the OTP sent to your mobile number"
            FormHelperTextProps={{
              style: { color: "white" },
            }}
            InputLabelProps={{
              style: { color: "white" },
            }}
            InputProps={{
              style: { color: "white" },
            }}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "#2c2c2c" }}>
        <Button
          variant="contained"
          sx={{
            background: "#2ABC4B",
            color: "white",
            alignSelf: "center",
            maxWidth: "400px",
            width: "70vw",
            borderRadius: "2rem",
          }}
          onClick={step === "enterMobile" ? handleSendOtp : handleVerifyOtp}
        >
          {step === "enterMobile" ? "Send OTP" : "Verify OTP"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginDialog;
